(function () {
	'use strict';

	/**
	 * @ngdoc component
	 * @name mx.components:mxChoice
	 * @module mx.components
	 * @restrict 'E'
	 * @description
	 * The mx-choice control is used to create a form where the user can choose needed form and input required data.
	 *
	 * The example below demonstrates some of the attributes you may use with the mxChoice control:
	 * @param {object[]} panels= - Array of defined panels where each `item` contains following parameters:
	 *
	 *  - `id` - {string} - Unique identifier of panel template;
	 *  - `title` - {string} - The title of the panel. It will be rendered as radio button label;
	 *  - `name` - {string} - The name of the panel. This parameter is used to define selected panel;
	 *  - `position` - {int} - Index of panel position. Lower value defines higher position;
	 *  - `disabled` - {boolean} - N/A (currently is not supported).
	 * @param {string} selectedPanelName= - Panel to be selected.
	 * @param {string} parentControllerAs@  - This will init parent controller scope.
	 * @param {enum} viewMode@? - View mode. Possible values: `radio_buttons_with_panels` / `radio_buttons_without_panels` / `selected_panel_without_radio_buttons`. Default: `radio_buttons_with_panels`
	 * @usage
	 *        <mx-choice
	 *            data-panels='[{id:"0", title:"Item 0", name:"panel0", disabled:"true", position: 0}, {id:"1", title:"Item 1", name:"panel1", disabled:"false", position: 1}]'
	 *            selected-panel-name='panel0'
	 *            view-mode='radio_buttons_with_panels'
	 *            >
	 *        </mx-choice>
	 *        <script type='text/ng-template'    id='0'>
	 *            <div>block0</div>
	 *            <mx-text-box ng-model="entity.text1" label="Label 0"></mx-text-box>
	 *        </script>
	 *        <script type='text/ng-template'    id='1'>
	 *            <div>block1</div>
	 *            <mx-checkbox ng-model="entity.text1" label="Label 1"></mx-checkbox>
	 *        </script>
	 */

	angular
		.module('mx.components')
		.component('mxChoice', {
			require: {
				mxForm: '?^^mxForm',
				mxUiAccessibility: '?^^mxUiAccessibility',
				form: '?^^form',
				repeaterItem: '?^^mxRepeaterItem',
			},
			bindings: {
				panels: '<',
				selectedPanelName: '=?',
				parentControllerAs: '@',
				viewModeParam: '@?viewMode',
				disabled: '<',
				direction: '@',
				directionHorizontalButtonsWidth: '@',
				hiddenPanels: '@',
			},
			templateUrl: 'mx-choice/mx-choice.html',
			controller: MxChoiceCtrl,
			controllerAs: '__$vm',
		})
		.filter('hidePanels', function hidePanelsFilter() {
			return function (input, hiddenPanels) {
				// Add commas to simplify validation
				hiddenPanels = ',' + hiddenPanels + ',';
				return input.filter(function (panel) {
					return hiddenPanels.indexOf(',' + panel.name + ',') === -1;
				});
			};
		})
		.value('mxChoiceNormalizeViewModeValue', function mxChoiceNormalizeViewModeValue(value) {
			// There was property called vm.showSwitchButtons {Boolean} till 11.0.0
			// but now it is renamed to vm.viewMode {Enum} with values: 'radio_buttons_with_panels', 'radio_buttons_without_panels', 'selected_panel_without_radio_buttons'
			// Here we map obsolete old values to new ones for Backward Compatibility
			if (['radio_buttons_with_panels', 'radio_buttons_without_panels', 'selected_panel_without_radio_buttons'].some((v) => v === value)) {
				return value;
			} else if (value === false || (value || '').toLowerCase?.() === 'false') {
				return 'selected_panel_without_radio_buttons';
			} else {
				// here `value` could be true/"True"/undefined/""
				return 'radio_buttons_with_panels';
			}
		});

	MxChoiceCtrl.$inject = ['$scope', '$filter', '$templateCache', 'mxChoiceNormalizeViewModeValue'];
	function MxChoiceCtrl($scope, $filter, $templateCache, mxChoiceNormalizeViewModeValue) {
		var vm = this;
		vm.uniqueClassName = mx.components.Utils.genElemId('mx-choice-');

		vm.$onInit = function () {
			vm.direction = vm.direction || 'column';
			vm.viewMode = mxChoiceNormalizeViewModeValue(vm.viewModeParam);
			vm.panels.sort(function (a, b) {
				return a.position - b.position;
			});
			vm._panels = [];

			if (typeof vm.selectedPanelName === 'undefined' && vm.panels.length > 0 && vm.panels[0].disabled) {
				vm.panels.some(function (panel) {
					if (!panel.disabled) {
						vm.selectedPanelName = panel.name;
						return true;
					}
				});
			}
			initScope();
		};

		$scope.$watchGroup(['__$vm.panels', '__$vm.hiddenPanels'], function () {
			vm._panels = $filter('orderBy')(
				$filter('hidePanels')(
					vm.panels.filter(function (t) {
						return t.visible === undefined || t.visible;
					}),
					vm.hiddenPanels
				),
				'position'
			);
		});

		$scope.$watch('__$vm.selectedPanelName', function () {
			vm._currentPanel = vm.panels.filter(function (panel) {
				return '' + panel.name === '' + vm.selectedPanelName; // To string
			})[0];
		});

		// Avoid using not existing template URLs because it can crash whole all with loading 404 and a lot of its requests
		vm.validateTemplateUrl = function (panelId) {
			return panelId && (panelId.indexOf('.html') !== -1 || $templateCache.get(panelId)) ? panelId : '';
		};

		//TODO: should we display any default panel if `selectedPanelName` not set ?

		function initScope() {
			if (vm.parentControllerAs) {
				$scope[vm.parentControllerAs] = getParent($scope, vm.parentControllerAs);
			} else {
				$scope.dataModel = $scope.$parent;
			}

			if (vm.repeaterItem) {
				$scope.item = vm.repeaterItem.item;
			}

			function getParent(scope, key) {
				return scope.$parent && (scope.$parent[key] || getParent(scope.$parent, key));
			}
		}
	}
})();
